'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagBfAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-3.05176e-05 0C9.33332 0 18.6667 -8.36891e-05 28 8.88109e-06V20C18.6667 20 9.33334 20 8.88109e-06 20C8.88109e-06 13.3333 0.000262814 6.66667 -3.05176e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.88109e-06 20H28V10H8.88109e-06V20Z",
          fill: "#00B051"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.88109e-06 10H28V8.88109e-06L-3.05176e-05 0L8.88109e-06 10Z",
          fill: "#FA494B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 12.2267L11.6489 13.9027L12.5164 11.1487L10.1958 9.4306L13.0831 9.4046L14 6.66667L14.917 9.4046L17.8042 9.4306L15.4837 11.1487L16.3512 13.9027L14 12.2267Z",
          fill: "#FDD216"
        }
      )
    ]
  }
);
const VpFlagBfAsset = forwardRef(FlagBfAsset);

export { VpFlagBfAsset as default };
